<div class="task-create-container">
  <h1 class="mat-headline-4">Criar tarefa</h1>

  <form [formGroup]="taskForm" (ngSubmit)="onSubmit()" class="task-form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Data alvo</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="targetDate" [min]="minDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Prioridade</mat-label>
        <mat-select formControlName="priority">
          @for (priority of priorities; track priority) {
            <mat-option [value]="priority.value">
              {{priority.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Recorrente</mat-label>
        <mat-select formControlName="recurrentType">
          @for (option of recurrentOptions; track option) {
            <mat-option [value]="option.value">
              {{option.label}}
            </mat-option>
          }
        </mat-select>
        @if (isRecurrent) {
          <mat-hint>As próximas 10 tarefas serão criadas</mat-hint>
        }
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Título</mat-label>
      <input matInput formControlName="title" placeholder="Digite o título da tarefa">
      @if (taskForm.get('title')?.hasError('required')) {
        <mat-error>
          Título é obrigatório
        </mat-error>
      }
      @if (taskForm.get('title')?.hasError('minlength')) {
        <mat-error>
          Título deve ter pelo menos 3 caracteres
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Descrição</mat-label>
      <textarea matInput formControlName="body" rows="4" placeholder="Digite a descrição da tarefa"></textarea>
      @if (taskForm.get('body')?.hasError('required')) {
        <mat-error>
          Descrição é obrigatória
        </mat-error>
      }
      @if (taskForm.get('body')?.hasError('minlength')) {
        <mat-error>
          Descrição deve ter pelo menos 10 caracteres
        </mat-error>
      }
    </mat-form-field>

    <div class="button-row">
      <button mat-raised-button color="accent" type="button" (click)="onCancel()">
        Cancelar
      </button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!taskForm.valid">
        Criar
      </button>
    </div>
  </form>
</div>
